module.exports = __webpack_public_path__ + "static/media/rich-people.1a2ff5fc.jpg";